import SVGRenderer from './SVGRenderer';

export default SVGRenderer;